import React, { useMemo } from "react";
import { Page } from "../../shared-components/Page";
import { GetStarted } from "./GetStarted";
import { Routes, Route } from "react-router-dom";

export const GetStartedRouter = (): React.ReactElement => {
  const breadCrumbs = useMemo(() => [{ text: "Get Started" }], []);
  return (
    <Routes>
      <Route
        path=""
        element={
          <Page title="Get Started" breadCrumbs={breadCrumbs}>
            <GetStarted />
          </Page>
        }
      />
    </Routes>
  );
};
